module.exports = __webpack_public_path__ + "static/media/video-pleasant-zh.538c0ae6.vtt";